export default __webpack_public_path__ + "static/media/lesson-note.1a045c2c.svg";